export const SupplyTypes = [
   {
      id: 0,
      // id: 'None',
      name: 'None',
      value: 0,
   },
   {
      id: 1,
      // id: 'Goods',
      name: 'Goods',
      value: 1,
   },
   {
      id: 2,
      // id: 'Service',
      name: 'Service',
      value: 2,
   },
   {
      id: 3,
      // id: 'CapitalGoods',
      name: 'CapitalGoods',
      value: 3,
   },
];

export const calculationMethod = [
   {
      id: 0,
      name: 'None',
   },
   {
      id: 1,
      name: 'Percentage',
   },
   {
      id: 2,
      name: 'Value',
   },
   {
      id: 3,
      name: 'Add Value',
   },
   {
      id: 4,
      name: 'Subtract Value',
   },
   {
      id: 5,
      name: 'Multiply by Value',
   },
   {
      id: 6,
      name: 'Divide by Value',
   },
];

export const calculationSign = [
   {
      id: -1,
      sign: '-1',
      name: 'Subtraction',
   },
   {
      id: 1,
      sign: '1',
      name: 'Addition',
   },
   {
      id: 0,
      sign: '0',
      name: 'Both',
   },
];

export const METHOD_OF_ROUND_LI_TYPE = [
   {
      id: 0,
      name: 'Truncate',
   },
   {
      id: 1,
      name: 'None',
   },
   {
      id: 2,
      name: 'Normal',
   },
   {
      id: 3,
      name: 'Plus',
   },
   {
      id: 4,
      name: 'Minus',
   },
];

export const EntryFromType = [
   {
      id: 0,
      // id: 'Without Item Detail',
      name: 'Without Item Detail',
   },
   {
      id: 1,
      // id: 'With Item Detail',
      name: 'With Item Detail',
   },
];

export const OrderFieldRegion = [
   {
      id: 0,
      // id: 'Header',
      name: 'Header',
   },
   // {
   //    id: 1,
   //    // id: 'LineItem',
   //    name: 'LineItem',
   // },
];

export const AUTO_ROUND_OFF_AT_TYPE = [
   {
      id: 0,
      name: 'None',
   },
   {
      id: 1,
      name: 'Line-Item',
   },
   {
      id: 2,
      name: 'Total',
   },
   {
      id: 3,
      name: 'Both',
   },
];

export const LINE_ITEM_REACHED = [
   {
      id: 0,
      // id: 'Warn and allow more lines',
      name: 'Warn and allow more lines',
   },
   {
      id: 1,
      // id: 'Block',
      name: 'Block',
   },
   {
      id: 2,
      // id: 'Block and jump to footer',
      name: 'Block and jump to footer',
   },
];

export const GL_GROUP_DROPDOWN = [
   {
      id: 18,
      name: 'Customer',
   },
   {
      id: 12,
      name: 'Vendor',
   },
];

export const AsseseeType = [
   {
      id: 0,
      name: 'Regular',
      value: 0,
   },
   {
      id: 1,
      name: 'Composite',
      value: 1,
   },
   {
      id: 2,
      name: 'Ecommerce',
      value: 2,
   },
   {
      id: 3,
      name: 'ISD',
      value: 3,
   },
   {
      id: 4,
      name: 'UIN holder',
      value: 4,
   },
];

export const BUSINESS_TYPE = [
   {
      id: 0,
      name: 'Manufacturer',
      value: 0,
   },
   {
      id: 1,
      name: 'Trader',
      value: 1,
   },
   {
      id: 2,
      name: 'Professional',
      value: 2,
   },
   {
      id: 3,
      name: 'Services',
      value: 3,
   },
   {
      id: 4,
      name: 'Personal',
      value: 4,
   },
   {
      id: 5,
      name: 'Others',
      value: 5,
   },
];

export const COMPOUND_METHOD = [
   {
      id: 0,
      name: 'No Compounding',
      value: 0,
   },
   {
      id: 1,
      name: 'Daily',
      value: 1,
   },
   {
      id: 2,
      name: 'Weekly',
      value: 2,
   },
   {
      id: 3,
      name: 'Monthly',
      value: 3,
   },
   {
      id: 4,
      name: 'Quarterly',
      value: 4,
   },
   {
      id: 5,
      name: 'Half Yearly',
      value: 5,
   },
   {
      id: 6,
      name: 'Yearly',
      value: 6,
   },
   {
      id: 7,
      name: 'By Compounding Days',
      value: 7,
   },
];

export const BLOOD_GROUP = [
   {
      id: 0,
      name: 'A+',
      value: 0,
   },
   {
      id: 1,
      name: 'A-',
      value: 1,
   },
   {
      id: 2,
      name: 'B+',
      value: 2,
   },
   {
      id: 3,
      name: 'B-',
      value: 3,
   },
   {
      id: 4,
      name: 'AB+',
      value: 4,
   },
   {
      id: 5,
      name: 'AB-',
      value: 5,
   },
   {
      id: 6,
      name: 'O+',
      value: 6,
   },
   {
      id: 7,
      name: 'O-',
      value: 7,
   },
];

export const MARITAL_STATUS = [
   {
      id: 0,
      name: 'Single',
      value: 0,
   },
   {
      id: 1,
      name: 'Married',
      value: 1,
   },
   {
      id: 2,
      name: 'Divorced',
      value: 2,
   },
   {
      id: 3,
      name: 'Widowed',
      value: 3,
   },
   {
      id: 4,
      name: 'Separated',
      value: 4,
   },
   {
      id: 5,
      name: 'Other',
      value: 5,
   },
];

export const CREDIT_LIMIT_TYPE = [
   {
      id: 0,
      name: 'Accept Value',
      value: 0,
   },
   {
      id: 1,
      name: 'No Limit',
      value: 1,
   },
   {
      id: 2,
      name: 'No Credit',
      value: 2,
   },
];

export const MSME_TYPE = [
   {
      id: 0,
      name: 'Others',
      value: 0,
   },
   {
      id: 1,
      name: 'Micro',
      value: 1,
   },
   {
      id: 2,
      name: 'Small',
      value: 2,
   },
   {
      id: 3,
      name: 'Medium',
      value: 3,
   },
];

export const COMPANY_TYPE = [
   {
      id: 0,
      name: 'INDIVIDUAL',
      value: 0,
   },
   {
      id: 1,
      name: 'HUF',
      value: 1,
   },
   {
      id: 2,
      name: 'PARTNERSHIP/LLP',
      value: 2,
   },
   {
      id: 3,
      name: 'AOP',
      value: 3,
   },
   {
      id: 4,
      name: 'BOI',
      value: 4,
   },
   {
      id: 5,
      name: 'TRUST',
      value: 5,
   },
   {
      id: 6,
      name: 'COMPANY',
      value: 6,
   },
];

export const PRICE_LEVELS = [
   {
      id: 1,
      name: 'Level 1',
      value: 1,
   },
   {
      id: 2,
      name: 'Level 2',
      value: 2,
   },
   {
      id: 3,
      name: 'Level 3',
      value: 3,
   },
   {
      id: 4,
      name: 'Level 4',
      value: 4,
   },
   {
      id: 5,
      name: 'Level 5',
      value: 5,
   },
   {
      id: 6,
      name: 'Level 6',
      value: 6,
   },
   {
      id: 7,
      name: 'Level 7',
      value: 7,
   },
   {
      id: 8,
      name: 'Level 8',
      value: 8,
   },
   {
      id: 9,
      name: 'Level 9',
      value: 9,
   },
   {
      id: 10,
      name: 'Level 10',
      value: 10,
   },
   {
      id: 11,
      name: 'Level 11',
      value: 11,
   },
   {
      id: 12,
      name: 'Level 12',
      value: 12,
   },
   {
      id: 13,
      name: 'Level 13',
      value: 13,
   },
   {
      id: 14,
      name: 'Level 14',
      value: 14,
   },
   {
      id: 15,
      name: 'Level 15',
      value: 15,
   },
   {
      id: 16,
      name: 'Level 16',
      value: 16,
   },
   {
      id: 17,
      name: 'Level 17',
      value: 17,
   },
   {
      id: 18,
      name: 'Level 18',
      value: 18,
   },
   {
      id: 19,
      name: 'Level 19',
      value: 19,
   },
   {
      id: 20,
      name: 'Level 20',
      value: 20,
   },
];

export const ActionMode = [
   {
      id: 0,
      name: 'Ignore',
      value: 0,
   },
   {
      id: 1,
      name: 'Warn',
      value: 1,
   },
   {
      id: 2,
      name: 'Confirm',
      value: 2,
   },
   {
      id: 3,
      name: 'Block',
      value: 3,
   },
];

export const LicensesType = [
   {
      id: 0,
      name: 'M I Licenses',
      value: 0,
   },
   {
      id: 1,
      name: 'M II Permit Holder',
      value: 1,
   },
   {
      id: 2,
      name: 'Distillery',
      value: 2,
   },
   {
      id: 3,
      name: 'Other',
      value: 3,
   },
];

export const TDS_APPLY_ON = [
   {
      id: 0,
      name: 'Net Amount',
      value: 0,
   },
   {
      id: 1,
      name: 'Taxable Amount',
      value: 1,
   },
   // {
   //    id: 1,
   //    name: 'Gross Amount',
   //    value: 1,
   // },
   // {
   //    id: 2,
   //    name: 'Net Amount Without GST',
   //    value: 2,
   // },
];

export const ASK_TO_GENERATE_INVOICE = [
   {
      id: 0,
      name: 'E Way Bill',
      value: 0,
   },
   {
      id: 1,
      name: 'Invoice',
      value: 1,
   },
   {
      id: 2,
      name: 'E Way Bill & Invoice',
      value: 2,
   },
   // {
   //   id: 3,
   //   name: 'Both',
   //   value: 3,
   // },
];
